import { Controller } from "@hotwired/stimulus";

// In conjunction with the autocomplete-field controller, we implement a _clearable_ field.  We could have extended the
// field controller, but this is reasonably clear (isTrusted discrimination aside) and isolates this behaviour.
export default class extends Controller {
  static targets = ["input", "hidden", "clear"];

  declare inputTarget: HTMLInputElement;
  declare hiddenTarget: HTMLInputElement;
  declare clearTarget: HTMLElement;
  declare hasClearTarget: boolean;

  edited = false;

  connect(): void {
    this.syncClearVisibility();
  }

  markEdited(): void {
    this.edited = true;
    this.syncClearVisibility();
  }

  commit(event: Event): void {
    if (!event.isTrusted) {
      // i.e. when the originating event is triggered by the controller, and _not_ when a browser-level change occurred
      this.edited = false;
    } else if (this.edited) {
      // Sourced from the browser; we have lost alignment between the input value and hidden field value, so clear both
      this.inputTarget.value = "";
      this.hiddenTarget.value = "";
    }

    this.syncClearVisibility();
  }

  clear(): void {
    this.inputTarget.value = "";
    this.hiddenTarget.value = "";
    this.edited = false;
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this.inputTarget.focus();
    this.syncClearVisibility();
  }

  syncClearVisibility(): void {
    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle("is-hidden", this.inputTarget.value === "");
    }
  }
}
